<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Lung Specific Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-4 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="secondarySpecification"
              class="secondarySpecification"
              disabled
              label="Secondary Specification"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="secondarySpecificationOATS"
              class="secondarySpecification"
              disabled
              label="Secondary Specification"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="predictedTLC"
              disabled
              label="Predicted TLC"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="predictedTLCOATS"
              disabled
              label="Predicted TLC"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="comments"
              class="comments"
              disabled
              label="COMMENTS-EMR"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="commentsOATS"
              class="comments"
              disabled
              label="COMMENTS-OATS"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="actualTLC"
              disabled
              label="Actual TLC "
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="actualTLCOATS"
              disabled
              label="Actual TLC "
            />
          </div>
        </div>
    
        
   
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="FEV1"
              disabled
              label="FEV1"
            />
          </div> 

          <div class="col-2">
            <ADSTextInput
              v-model="FEV1OATS"
              disabled
              label="FEV1"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="predictedFVC"
              disabled
              label="Predicted FVC"
            />
          </div> 

          <div class="col-2">
            <ADSTextInput
              v-model="predictedFVCOATS"
              disabled
              label="Predicted FVC"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="perfusionRight"
              disabled
              label="Perfusion Right"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="perfusionRightOATS"
              disabled
              label="Perfusion Right"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="perfusionLeft"
              disabled
              label="Perfusion Left"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="perfusionLeftOATS"
              disabled
              label="Perfusion Left"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="estRVPressSYS"
              disabled
              label="Estimated RV Systolic Pressure"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="estRVPressSYSOATS"
              disabled
              label="Estimated RV Systolic Pressure"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="systolicPAPressure"
              disabled
              label="Systolic PA Pressure"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="systolicPAPressureOATS"
              disabled
              label="Systolic PA Pressure"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="diastolicPAPressure"
              disabled
              label="Diastolic PA Pressure"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="diastolicPAPressureOATS"
              disabled
              label="Diastolic PA Pressure"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="echoDate"
              disabled
              label="Echo Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="echoDateOATS"
              disabled
              label="Echo Date"
            />
          </div>
        </div>
        
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="meanPAPressure"
              disabled
              label="Mean PA Pressure"
            />
          </div>
          
          <div class="col-4">
            <ADSTextInput
              v-model="meanPAPressureOATS"
              disabled
              label="Mean PA Pressure"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="chestCTResults"
              class="chestCTResults"
              disabled
              label="Chest CT Results"
            />
          </div>
          
          <div class="col-4">
            <ADSTextInput
              v-model="chestCTResultsOATS"
              class="chestCTResults"
              disabled
              label="Chest CT Results"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="echoComment"
              class="echoComment"
              disabled
              label="Echo Comment"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="echoCommentOATS"
              class="echoComment"
              disabled
              label="Echo Comment"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="chestCTDate"
              disabled
              label="Chest CT Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="chestCTDateOATS"
              disabled
              label="Chest CT Date"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

/** Labels match TGLN `ValueConversions.SECONDARY_SPEC_CODE` (internal code -> external / display). */
const SECONDARY_SPEC_CODE_TO_LABEL = new Map( [
  [ '401', 'Double only' ],
  [ '421', 'Double/single either side' ],
  [ '423', 'Double/left single only' ],
  [ '422', 'Double/right single only' ],
  [ '402', 'Right single only' ],
  [ '403', 'Left single only' ],
  [ '411', 'Single only, either side' ],
  [ '433', 'Double/left side preferred' ],
] );

export default {
  name: "LungSpecificSectionDetailsEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      secondarySpecification: this.getSecondarySpecification( this.patientBundle ),
      secondarySpecificationOATS: this.getSecondarySpecificationOATS( this.patientBundleOATS ),
      predictedTLC: this.getPredictedTLC( this.patientBundle ),
      predictedTLCOATS: this.getPredictedTLCOATS( this.patientBundleOATS ),
      actualTLC: this.getActualTLC( this.patientBundle ),
      actualTLCOATS: this.getActualTLCOATS( this.patientBundleOATS ),
      FEV1: this.getFEV1( this.patientBundle ), 
      FEV1OATS: this.getFEV1OATS( this.patientBundleOATS ),
      predictedFVC: this.getPredictedFVC( this.patientBundle ), 
      predictedFVCOATS: this.getPredictedFVCOATS( this.patientBundleOATS ),
      comments: this.getComments( this.patientBundle ),
      commentsOATS: this.getCommentsOATS( this.patientBundleOATS ),
      perfusionRight: this.getPerfusionRight( this.patientBundle ),
      perfusionRightOATS: this.getPerfusionRightOATS( this.patientBundleOATS ),
      perfusionLeft: this.getPerfusionLeft( this.patientBundle ),
      perfusionLeftOATS: this.getPerfusionLeftOATS( this.patientBundleOATS ),
      estRVPressSYS: this.getESTRVPressSYS( this.patientBundle ),
      estRVPressSYSOATS: this.getESTRVPressSYSOATS( this.patientBundleOATS ),
      systolicPAPressure: this.getSystolicPAPressure( this.patientBundle ),
      systolicPAPressureOATS: this.getSystolicPAPressureOATS( this.patientBundleOATS ),
      diastolicPAPressure: this.getDiastolicPAPressure( this.patientBundle ),
      diastolicPAPressureOATS: this.getDiastolicPAPressureOATS( this.patientBundleOATS ),
      meanPAPressure: this.getMeanPAPressure( this.patientBundle ),
      meanPAPressureOATS: this.getMeanPAPressureOATS( this.patientBundleOATS ),
      echoComment: this.getEchoComment( this.patientBundle ),
      echoCommentOATS: this.getEchoCommentOATS( this.patientBundleOATS ),
      echoDate: this.getEchoDate( this.patientBundle ),
      echoDateOATS: this.getEchoDateOATS( this.patientBundleOATS ),
      chestCTResults: this.getChestCTResults( this.patientBundle ),
      chestCTResultsOATS: this.getChestCTResultsOATS( this.patientBundleOATS ),
      chestCTDate: this.getChestCTDate( this.patientBundle ),
      chestCTDateOATS: this.getChestCTDateOATS( this.patientBundleOATS ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) { 
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getSecondarySpecification( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#1652' );
    },
    getSecondarySpecificationOATS( patientBundleOATS ) {
      const journeys = patientBundleOATS?.journeys?.filter( ( n ) =>
        n.organ_code === 4 && n.state !== 'cancelled' && n.state !== 'declined'
      );
      const code = journeys?.[ 0 ]?.organ_specific_details?.organ_specification_preference_code;
      if( code === null || code === undefined || code === '' ) {
        return null;
      }
      const key = String( code ).trim();
      return SECONDARY_SPEC_CODE_TO_LABEL.get( key ) ?? key;
    },
    getPredictedTLC( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#1886' );
    },
    getPredictedTLCOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.predicted_total_lung_capacity;
      }
    },
    getActualTLC( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#2849', 'valueQuantity.value' );
    },
    getActualTLCOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.actual_total_lung_capacity;
      }
    },
    getFEV1( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3770' );
    },
    getFEV1OATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.actual_forced_expiratory_volume;
      }
    },
    getPredictedFVC( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3769' );
    },
    getPredictedFVCOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.predicted_forced_vital_capacity;
      }
    },
    getComments( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'EPIC#31000156420' );
    },
    getCommentsOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].comments;
      }
    },
    getPerfusionRight( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4160' );
    },
    getPerfusionRightOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.perfusion_right;
      }
    },
    getPerfusionLeft( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4161' );
    },
    getPerfusionLeftOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.perfusion_left;
      }
    },
    getESTRVPressSYS( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4162' );
    },
    getESTRVPressSYSOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.estimated_right_ventricular_systolic_pressure;
      }
    },
    getSystolicPAPressure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4163' );
    },
    getSystolicPAPressureOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.pulmonary_artery_systolic_pressure;
      }
    },
    getDiastolicPAPressure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4164' );
    },
    getDiastolicPAPressureOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.pulmonary_artery_diastolic_pressure;
      }
    },
    getMeanPAPressure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4165' );
    },
    getMeanPAPressureOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.pulmonary_mean_arterial_pressure;
      }
    },
    getEchoComment( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4167' );
    },
    getEchoCommentOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.echocardiogram_comment;
      }
    },
    getEchoDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4170', 'valueDateTime' );
    },
    getEchoDateOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.echocardiogram_date;
      }
    },
    getChestCTResults( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4169' );
    },
    getChestCTResultsOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.chest_ct_scan_result;
      }
    },
    getChestCTDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4171', 'valueDateTime' );
    },
    getChestCTDateOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 4 && ( n.state !== 'cancelled' && n.state !== 'declined' ) ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].organ_specific_details?.chest_ct_scan_date;
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 1800px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.secondarySpecification .afflo-ds-form-control) {
  width: 300px;
} 

:deep(.comments .afflo-ds-form-control) {
  width: 700px;
} 

:deep(.echoComment .afflo-ds-form-control) {
  width: 300px;
} 

:deep(.chestCTResults .afflo-ds-form-control) {
  width: 300px;
} 

</style>
